import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    organization: '',
    email: '',
    sector: '',
    struggle: '',
    referral: ''
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the data to your backend
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <div className="hero-content">
            <h1>Let's build your next system</h1>
            <p className="hero-subtitle">
              Share a bit about your organization and what you're trying to fix.
              We'll follow up with a clear next step.
            </p>
          </div>
        </div>
      </section>

      {/* Form Section */}
      <section className="section">
        <div className="container">
          <div className="contact-form-container">
            {!isSubmitted ? (
              <>
                <p className="form-intro">
                  We typically respond within a few business days and start with a low-pressure discovery call.
                </p>

                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="fullName" className="form-label">
                        Full Name <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        id="fullName"
                        name="fullName"
                        className="form-input"
                        value={formData.fullName}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="organization" className="form-label">
                        Organization <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        id="organization"
                        name="organization"
                        className="form-input"
                        value={formData.organization}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="email" className="form-label">
                        Email <span className="required">*</span>
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-input"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="sector" className="form-label">
                        Sector
                      </label>
                      <select
                        id="sector"
                        name="sector"
                        className="form-select"
                        value={formData.sector}
                        onChange={handleChange}
                      >
                        <option value="">Select a sector</option>
                        <option value="nonprofit">Nonprofit / Foundation</option>
                        <option value="education">Education / Youth</option>
                        <option value="startup">Social Impact Startup</option>
                        <option value="capital">Family Office / Capital Partner</option>
                        <option value="government">Government / Public Sector</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="struggle" className="form-label">
                      What are you currently struggling with? <span className="required">*</span>
                    </label>
                    <textarea
                      id="struggle"
                      name="struggle"
                      className="form-textarea"
                      value={formData.struggle}
                      onChange={handleChange}
                      placeholder="Tell us about your current challenges..."
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="referral" className="form-label">
                      How did you hear about Pathway Labs?
                    </label>
                    <input
                      type="text"
                      id="referral"
                      name="referral"
                      className="form-input"
                      value={formData.referral}
                      onChange={handleChange}
                      placeholder="Optional"
                    />
                  </div>

                  <button type="submit" className="btn btn-primary btn-large submit-btn">
                    Submit Inquiry
                  </button>
                </form>

                {/* Contact Page Disclaimer */}
                <div className="contact-disclaimer">
                  <p>
                    By submitting this form, you acknowledge that Pathway Labs provides software
                    and digital tools for informational purposes. We do not provide legal, tax,
                    or compliance advice. Please consult qualified professionals for regulatory
                    and legal matters.
                  </p>
                </div>
              </>
            ) : (
              <div className="confirmation-message">
                <div className="confirmation-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22 4 12 14.01 9 11.01" />
                  </svg>
                </div>
                <h2>Thank you</h2>
                <p>
                  We've received your message and will follow up with next steps.
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
